import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
  @observable data = {
    loading: false,
    displayBtn: false,
    toastContent: "",
    GroupSupper: {
      lastWeekRecord: {
        rewardMembers: []
      }
    },
    includeOwner: false,
    canSelectOwner: false,
    admins: [],
    otherDgid: 0,
    otherGid: 0,
    haveSign: false,
    roomList:[],
  }

  //会员
  @action async GroupSupper() {
    console.log("GroupSupper")
    let d = await http.post('/web/GroupSupper', {})
    if (!d.res.lastWeekRecord) {
      d.res.lastWeekRecord = {
        rewardMembers: []
      }
    } else {
      this.data.haveSign = true
    }
    this.data.GroupSupper = d.res
    this.data.displayBtn = true
    return
  }

  //管理员名单
  @action async GroupAdmins() {
    console.log("GroupAdmins")
    let d = await http.post('/web/GroupSupper/GroupAdmins', {})
    this.data.includeOwner = d.res.includeOwner
    this.data.admins = d.res.admins
    this.data.adminsBak = d.res.admins
    this.data.canSelectOwner = d.res.canSelectOwner
    this.data.otherDgid = d.res.otherDgid
    this.data.otherGid = d.res.otherGid
    if (d.res.canSelectOwner == false) {
      this.data.includeOwner = false
    }
    return d
  }

  @action async setAdmins() {
    this.data.admins = this.data.adminsBak
  }

  //报名
  @action async GroupSupperApply() {
    console.log("GroupSupperApply")
    let map = {
      includeOwner: this.data.includeOwner,
      memberUids: []
    }
    //排序
    let idx = 1
    for (let i = 0; i < this.data.admins.length; i++) {
      for (let ii = 0; ii < this.data.admins.length; ii++) {
        if (idx == this.data.admins[ii].idx) {
          map.memberUids.push(this.data.admins[ii].uid)
          idx++
        }
      }
      if (idx > this.data.admins.length) {
        break
      }
    }
    this.data.loading = true
    let d = await http.post('/web/GroupSupper/Apply', map)
    this.data.loading = false
    this.GroupSupper()
    return d
  }

  //修改报名名单
  @action async UpdateRewordMembers() {
    console.log("UpdateRewordMembers")
    let map = {
      includeOwner: this.data.includeOwner,
      memberUids: []
    }
    //排序
    let idx = 1
    for (let i = 0; i < this.data.admins.length; i++) {
      for (let ii = 0; ii < this.data.admins.length; ii++) {
        if (idx == this.data.admins[ii].idx) {
          map.memberUids.push(this.data.admins[ii].uid)
          idx++
        }
      }
      if (idx > this.data.admins.length) {
        break
      }
    }
    console.log(map)
    this.data.loading = true
    let d = await http.post('/web/GroupSupper/UpdateRewordMembers', map)
    this.data.loading = false
    return d
  }

  @action async setToastContent(content) {
    this.data.toastContent = content
  }

  @action async setIncludeOwner() {
    if (this.data.canSelectOwner == true) {
      this.data.includeOwner = !this.data.includeOwner
    }
  }

  @action async cancelReward(gid) {
    console.log(gid)
    if (gid!=undefined) {
      this.data.loading = true
      let map = {
        otherGid:gid
      }
      let d = await http.post('/web/GroupSupper/member/cancel', map)
      this.data.loading = false
      this.GroupSupper()
      this.GroupAdmins()
    }
  }

  @action async setOrder(uid) {
    console.log("设置", uid)
    let maxIdx = 0 //最高idx
    let currentIdx = 0 //当前idx
    let cancel = false //是否取消
    let admins = this.data.admins
    for (var i = 0; i < admins.length; i++) {
      if (admins[i].idx > maxIdx) {
        maxIdx = admins[i].idx
      }
      if (uid == admins[i].uid) {
        currentIdx = admins[i].idx
        if (admins[i].idx > 0) {
          cancel = true
        }
      }
    }

    console.log(maxIdx, currentIdx, cancel)

    for (var i = 0; i < admins.length; i++) {
      if (uid == admins[i].uid) { //当前用户
        if (cancel) { //取消
          console.log("取消")
          admins[i].idx = 0
        }
        if (!cancel && maxIdx < 23) { //设置到最后一位
          console.log("设置")
          admins[i].idx = maxIdx + 1
        }
      } else {
        if (cancel && admins[i].idx > currentIdx && admins[i].idx > 0) { //其他uid减去-1
          admins[i].idx = admins[i].idx - 1
        }
      }
    }

    this.data.admins = []
    this.data.admins = admins
  }
  //获取可操作房间
  @action async getRoomList(){
     let res = await http.post('/web/GroupSupper/group/mysupport')
     if (res.code == 0 ) {
      this.roomList = res.res
     }
  }
  //删除房间，单项操作
  @action async delectRoomItem(uid){
    let map = {
      OtherGid:uid
    }
    let res = await http.post(`/web/GroupSupper/member/cancel`,map)
    return res
  }
}



// WEBPACK FOOTER //
// src/store/app/roomsupport.js